import { client } from "api";
import { Company } from "models/Company";
import { CompanyContact } from "models/CompanyContact";

export type DeleteContactRequest = { companyId: Company["id"] } & Pick<CompanyContact, "id">;

export type DeleteContactResponse = CompanyContact[];

export const deleteContact = ({ companyId, id }: DeleteContactRequest) =>
  client.delete<DeleteContactResponse>(`/company/${companyId}/contacts/${id}`).then((res) => res.data);
